import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function PageTitle() {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/") {
      document.title = "Client";
    } else if (location.pathname.startsWith("/admin")) {
      document.title = "Admin Dashboard";
    } else if (location.pathname.startsWith("/user")) {
      document.title = "User Dashboard";
    } else {
      document.title = "Client";
    }
  }, [location]);

  return null;
}
